import "./languages";
import "./theme";
import "./plugins";

import Editor from "@tinymce/tinymce-vue";

export const TinymceEditor = Editor;
